import styles from './LoginCard.module.css';

const LoginCard = ({ children, onSubmit }) => {
  return (
    <div className={styles.card}>
      <form onSubmit={onSubmit} className={styles.form}>
        {children}
      </form>
    </div>
  );
};

export default LoginCard;
